import { useState, useEffect } from "react";
import { FiHeart, FiX } from "react-icons/fi";
import { interactionAPI } from "../api/endpoints";
import ContentCard from "../components/ContentCard";
import { toast } from "react-toastify";

export default function Watchlist() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [removing, setRemoving] = useState(null); // id of item being removed

  useEffect(() => {
    interactionAPI
      .getWatchlist()
      .then((res) => {
        const data = res.data;
        setItems(Array.isArray(data) ? data : data?.watchlist || data?.data || []);
      })
      .catch((err) => {
        console.error("[Watchlist] Failed:", err.response?.status, err.response?.data);
        setError(err.response?.data?.message || "Failed to load watchlist");
      })
      .finally(() => setLoading(false));
  }, []);

  const handleRemove = async (item) => {
    const itemType = item.type || item.content_type || "movie";
    setRemoving(item.id);
    try {
      await interactionAPI.watchlistEvent(item.watchlist_id, itemType, "delete");
      setItems((prev) => prev.filter((i) => i.id !== item.id));
      toast.success("Removed from watchlist");
    } catch {
      toast.error("Failed to remove");
    } finally {
      setRemoving(null);
    }
  };

  return (
    <div className="min-h-screen bg-dark-900 pt-20 pb-16">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <h1 className="text-2xl font-bold text-white mb-2">My Watchlist</h1>
        <p className="text-gray-500 text-sm mb-8">Content you've saved for later</p>

        {loading ? (
          <div className="flex justify-center py-20">
            <div className="w-10 h-10 border-3 border-primary border-t-transparent rounded-full animate-spin" />
          </div>
        ) : error ? (
          <div className="flex flex-col items-center justify-center py-20 text-gray-500">
            <p className="text-lg font-medium text-red-400">{error}</p>
            <button onClick={() => window.location.reload()} className="mt-4 text-sm text-primary hover:text-primary-hover">
              Try again
            </button>
          </div>
        ) : items.length > 0 ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4">
            {items.map((item) => (
              <div key={item.id} className="relative group/card">
                <ContentCard item={item} type={item.type || item.content_type} fromWatchlist />
                {/* Remove button */}
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRemove(item);
                  }}
                  disabled={removing === item.id}
                  className="absolute top-2 right-2 z-10 p-1.5 rounded-full bg-black/70 hover:bg-red-600 text-gray-400 hover:text-white transition-all opacity-0 group-hover/card:opacity-100 disabled:opacity-50"
                  title="Remove from watchlist"
                >
                  <FiX size={16} />
                </button>
              </div>
            ))}
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center py-20 text-gray-500">
            <FiHeart size={48} className="mb-4 text-gray-700" />
            <p className="text-lg font-medium">Your watchlist is empty</p>
            <p className="text-sm mt-1">Start adding movies and shows you want to watch</p>
          </div>
        )}
      </div>
    </div>
  );
}
